import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import dashboardApi from '../../dashboard/services/dashboardApi';
import Dashboard from '../../dashboard/Dashboard';

function PublicDashboardPage() {
  const { publicToken } = useParams();
  const [dashboardData, setDashboardData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  // Load public dashboard on mount
  useEffect(() => {
    const loadPublicDashboard = async () => {
      if (!publicToken) {
        setError('Invalid dashboard link');
        setIsLoading(false);
        return;
      }

      setIsLoading(true);
      setError(null);
      try {
        const dashboard = await dashboardApi.dashboards.fetch();
        setDashboardData(dashboard);
      } catch (err) {
        setError('Dashboard not found or access denied.');
      } finally {
        setIsLoading(false);
      }
    };

    loadPublicDashboard();
  }, [publicToken]);

  if (isLoading) {
    return <div style={{ padding: '20px' }}>Loading dashboard...</div>;
  }

  if (error) {
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <p>{error}</p>
      </div>
    );
  }

  if (!dashboardData) {
    return (
      <div style={{ padding: '20px' }}>
        <p>No dashboard data available.</p>
      </div>
    );
  }

  return (
    <Dashboard
      dashboard={dashboardData}
      onSave={null}
      isViewOnly
    />
  );
}

export default PublicDashboardPage;
